import {css} from 'lit';
export const styles = css`:host {
  position: relative;
  display: block;
}

  :host xs-group-item-2 {
    --padding: 16px var(--page-padding-x);
  }

  @media (min-width: 992px) {

  :host xs-group-item-2 {
      --padding: 16px
  }
    }

  @media (max-width: 991px) {:host {
    --border-radius: 0
}
  }

slot::slotted([slot='right']) {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

[slot='main'] {
  margin: 0;
}
`;
export default styles;
